<template>
  <div>
    <div class="row">
      <div class="col-12 mt-5">
        <h5>
          <span>Recursos</span>
        </h5>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-md-6">
        <CustomInput :icon="'fa fa-search'">
          <input type="text" slot="input" placeholder="Buscar" />
        </CustomInput>
      </div>
      <div class="col-md-6">
        <CustomInput :icon="'fa fa-filter'">
          <input type="text" slot="input" placeholder="Filtrar por" />
        </CustomInput>
      </div>
    </div>
    <div class="row pb-2">
      <div class="title">
        A los estudiantes:
      </div>
    </div>
    <div class="row pb-4">
      <div class="col-12 video-responsive">
        <iframe
          src="https://assets.beereaders.com/lbr/media/videos-demo/885566.mp4"
          frameborder="0"
          allow="fullscreen"
          allowfullscreen
        ></iframe>
      </div>
    </div>
    <div class="row pb-2">
      <div class="title">
        A los profesores:
      </div>
    </div>
    <div class="row">
      <div class="col-12 video-responsive">
        <iframe
          src="https://player.vimeo.com/video/414555649"
          frameborder="0"
          allow="fullscreen"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import CustomInput from "@/components/CustomInput";

export default {
  name: "root",
  components: {
    CustomInput,
  },
};
</script>
